var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo3(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 151,
    height: 132,
    viewBox: "0 0 151 132",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M144.356 20.8194C132.946 14.6515 103.835 0 103.835 0V14.0873C103.835 16.5389 60.6857 44.7031 49.6828 50.3165C39.6687 54.9668 19.3593 43.5357 19.3593 43.5357L3.21847 52.2136C1.23116 53.274 0.0387753 55.3656 0.0969405 57.6324L0 107.248L40.9386 130.957C41.782 131.443 42.7029 131.686 43.6239 131.686C44.5255 131.686 45.4367 131.453 46.251 130.976C60.4433 122.901 131.987 81.8857 147.071 67.4291C149.426 65.1623 150.774 61.9908 150.774 58.722V31.7155C150.764 27.143 148.302 22.9695 144.347 20.8194H144.356Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo3);
export default __webpack_public_path__ + "static/media/logo-3.293f1b97f39273636df633f038b87a0d.svg";
export { ForwardRef as ReactComponent };